module.exports = "./img/1b9eccc9d3019fc916a91721ed172c7d.png";